import * as yup from 'yup';

export const loginValidator = yup.object({
    username: yup.string().required().label('Member ID'),
    password: yup.string().required(),
    recaptcha: yup.string().required().label("Recaptcha challenge"),
})
;

